(() => {
  'use strict';
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const strings = {...JSON.parse($('#FitStrings')?.textContent || '{}'), ...JSON.parse($('#FitV2Strings')?.textContent || '{}')};
  const core = window.AtelierFitCore;
  const root = (document.body.dataset.root || '/').replace(/\/?$/, '/');
  let request, sourceForm, catalogPromise, profilesPromise;
  const el = (tag, className, content) => { const node = document.createElement(tag); if (className) node.className = className; if (content !== undefined) node.textContent = content; return node; };
  async function json(url) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try { const response = await fetch(url, { signal:controller.signal }); if (!response.ok) throw new Error(strings.error); return await response.json(); }
    finally { clearTimeout(timer); }
  }
  const text = key => strings[key] || '';
  function profileNote(profile, studio) {
    const node = el('div', 'fit-source');
    node.append(el('p', '', text(profile?.status === 'inferred_reference' ? 'v2_inferred' : profile?.status === 'manufacturer_reference' ? 'v2_manufacturer' : profile?.status === 'verified' ? 'fit_verified' : 'fit_published')));
    if (profile?.estimatedSizes?.length) node.append(el('p', '', text('v2_inferred_sizes').replace('{sizes}', profile.estimatedSizes.join(', '))));
    if (profile?.source?.startsWith('/pages/')) { const link = el('a', 'text-link', text('fit_source')); link.href = root.replace(/\/$/,'') + profile.source; link.target = '_blank'; link.rel = 'noopener'; node.append(link); }
    return node;
  }
  function drawChart(profile, studio) {
    const host = $('[data-fit-chart]', studio); host.replaceChildren();
    if (!profile?.rows?.length) { host.append(el('p', 'fit-pending', text('fit_pending'))); return; }
    const details = el('details', 'accordion fit-chart'); details.open = true; const summary = el('summary', '', text('fit_chart'));
    const scroll = el('div', 'table-scroll'); const table = el('table');
    const caption = el('caption', 'sr-only', text('fit_no_body') + ' · cm'); table.append(caption);
    const thead = el('thead'); const row = el('tr');
    [text('size'),text('fit_width_short') + ' · cm',text('fit_length_short') + ' · cm'].forEach(name => { const th = el('th', '', name); th.scope = 'col'; row.append(th); }); thead.append(row); table.append(thead);
    const tbody = el('tbody'); profile.rows.forEach(size => { const tr = el('tr'); const th = el('th','',size.size); th.scope='row'; tr.append(th, el('td','',String(size.width)),el('td','',String(size.length))); tbody.append(tr); }); table.append(tbody); scroll.append(table); details.append(summary,scroll,profileNote(profile,studio)); host.append(details);
  }
  function applySize(size, variants, studio) {
    const matching = variants.filter(v => v.options.some(option => core.normalise(option) === core.normalise(size)));
    const candidates = matching.filter(v => v.available);
    if (!candidates.length) return el('p', 'fit-stock-note', text('fit_unavailable'));
    if (candidates.length > 1) { const a = el('a','text-link',text('fit_select_variant')); a.href = studio.dataset.productUrl; return a; }
    const button = el('button','button fit-apply',text('fit_choose_size') + ' · ' + size); button.type='button';
    button.addEventListener('click', () => {
      const variant = candidates[0];
      const select = sourceForm?.isConnected && $('select[name="id"]', sourceForm);
      if (!select || ![...select.options].some(o => o.value === variant.id && !o.disabled)) {
        const url = new URL(studio.dataset.productUrl,location.origin); url.searchParams.set('variant',variant.id); location.assign(url); return;
      }
      select.value = variant.id; select.dispatchEvent(new Event('change', { bubbles: true }));
      const quick = sourceForm.closest('#QuickDialog');
      if (quick) window.AtelierDialogs?.open('QuickDialog');
      else { $('#FitDialog').close(); sourceForm.scrollIntoView({ behavior: 'instant', block:'center' }); $('input[name="variant-choice"]:checked',sourceForm)?.focus({preventScroll:true}); }
    });
    return button;
  }
  function showResult(result, current, reference, profile, variants, studio, details) {
    const host = $('[data-fit-result]', studio); host.replaceChildren(); host.hidden=false;
    const errors={different_pattern:'fit_different',need_measures:'fit_different',invalid:'fit_invalid',outside_range:'fit_outside',unverified:'fit_pending'};
    if (errors[result.kind]) {
      host.append(el('p','fit-result-message',text(errors[result.kind])));
      if (profile?.rows?.length) { const button=el('button','text-link',text('fit_chart'));button.type='button';button.addEventListener('click',()=>{ $('[data-fit-mode="measure"]',studio).click();$('.fit-chart',studio).open=true;$('.fit-chart',studio).scrollIntoView({block:'nearest',behavior:'instant'}); });host.append(button); }
    }
    else if (result.kind === 'same_product') {
      host.append(el('p','eyebrow',text('fit_same_pattern')),el('div','fit-size-answer',result.size));
      host.append(el('p','fit-reference-line',reference.title + ' → ' + current.title));
      host.append(el('p','fit-result-note',text(result.preference === 'same' ? 'fit_known_note' : 'fit_change')));
      host.append(applySize(result.size,variants,studio));
    } else {
      host.append(el('h3','fit-result-title',text(result.kind === 'between' ? 'fit_between' : 'fit_nearest')));
      if (result.kind === 'between') host.append(el('p','fit-result-note',text('fit_between_note')));
      const cards=el('div','fit-choices');
      result.choices.forEach(choice => {
        const card=el('div','fit-choice'); card.append(el('div','fit-size-answer',choice.size));
        const dl=el('dl','fit-comparison');
        [[text('fit_width_short'),choice.width,choice.deltaWidth],[text('fit_length_short'),choice.length,choice.deltaLength]].forEach(([name,value,delta])=>{
          dl.append(el('dt','',name),el('dd','',value+' cm'));
          if (delta !== null) dl.append(el('dt','muted',text('fit_difference')),el('dd','fit-delta',(delta>0?'+':'')+delta+' cm'));
        });
        card.append(dl,applySize(choice.size,variants,studio)); cards.append(card);
      });
      host.append(cards);
      if (result.lengthMismatch) host.append(el('p','fit-length-warning',text('fit_length_warning')));
      host.append(profileNote(profile,studio));
    }
    host.scrollIntoView({behavior:'instant',block:'nearest'});
  }
  async function init(studio, signal) {
    catalogPromise ||= json(studio.dataset.catalogUrl).catch(error=>{catalogPromise=null;throw error;});
    profilesPromise ||= json(studio.dataset.profilesUrl).catch(error=>{profilesPromise=null;throw error;});
    const [catalog, profiles] = await Promise.all([catalogPromise, profilesPromise]);
    if (signal.aborted || !studio.isConnected) return;
    const current = catalog.products.find(p=>p.id === studio.dataset.productId) || {id:studio.dataset.productId,title:$('.fit-product h2',studio).textContent};
    const custom=JSON.parse($('[data-fit-profile]',studio)?.textContent || 'null');
    const profile=core.selectProfile(current,profiles,custom);
    profiles.profiles=Object.fromEntries(catalog.products.map(p=>[p.id,core.selectProfile(p,profiles,null)]).filter(([,p])=>p));
    if (current.family === 'tank' || current.pattern === 'WT004') $('[data-fit-outline]',studio)?.setAttribute('d','M80 26h23c0 33 42 33 42 0h25c-2 39 2 57 13 68l-5 120H73L68 94c13-11 15-29 12-68Z');
    const variants=JSON.parse($('[data-fit-variants]',studio).textContent);
    if (studio.querySelector('[data-fit-v2]')) {
      if (!window.AtelierFitV2) throw new Error(text('error'));
      window.AtelierFitV2.mount({studio,current,profile,variants,catalog,profiles,core,strings,root,applySize});
      return;
    }
    const productSelect=$('#FitKnownProduct',studio), sizeSelect=$('#FitKnownSize',studio);
    const references=catalog.products.filter(p=>p.sizes?.length && p.pattern===current.pattern).sort((a,b)=>a.title.localeCompare(b.title));
    const availability=el('div','fit-availability');
    availability.append(el('p','',text(profile?.rows?.length ? 'fit_compatible' : 'fit_no_measurements')));
    $('[data-fit-panel="known"]',studio).prepend(availability);
    if (!profile?.rows?.length) {
      const measureButton=$('[data-fit-mode="measure"]',studio);
      measureButton.hidden=true;
      $('[data-fit-measure-form]',studio).hidden=true;
      const alternatives=el('details','accordion');alternatives.append(el('summary','',text('fit_available_alternatives')));
      const list=el('div','fit-alternatives');
      const choices=catalog.products.filter(p=>profiles.profiles[p.id]?.rows?.length).sort((a,b)=>Number(b.family===current.family)-Number(a.family===current.family)).slice(0,4);
      choices.forEach(p=>{const a=el('a');a.href=root+'products/'+p.handle;a.dataset.fitUrl=a.href;a.dataset.open='FitDialog';if(p.image){const img=el('img');const u=new URL(p.image);u.searchParams.set('width','100');img.src=u.href;img.alt='';img.width=44;img.height=55;img.loading='lazy';a.append(img);}a.append(el('span','',p.label||p.title));list.append(a);});
      alternatives.append(list);studio.insertBefore(alternatives,$('.fit-privacy',studio));
    }
    const initialOption=productSelect.firstElementChild;
    function renderReferences(query='') {
      const selected=productSelect.value;
      productSelect.replaceChildren(initialOption);
      references.filter(p=>(p.label || p.title).toLocaleLowerCase().includes(query.toLocaleLowerCase().trim())).forEach(p=>{ const option=el('option','',p.label || p.title); option.value=p.id; productSelect.append(option); });
      productSelect.value=selected;
      if (!productSelect.value) productSelect.dispatchEvent(new Event('change'));
    }
    renderReferences();
    $('#FitSearch',studio).addEventListener('input',event=>renderReferences(event.target.value));
    productSelect.addEventListener('change',()=>{
      const ref=catalog.products.find(p=>p.id === productSelect.value); sizeSelect.replaceChildren();
      const preview=$('[data-fit-reference-preview]',studio); preview.replaceChildren(); preview.hidden=!ref;
      if (ref) { if (ref.image) { const img=el('img'); const url=new URL(ref.image); url.searchParams.set('width','160'); img.src=url.href; img.alt=ref.label || ref.title; img.width=64; img.height=80; preview.append(img); } preview.append(el('p','',ref.label || ref.title)); }
      const initial=el('option','',text('choose'));initial.value='';sizeSelect.append(initial);sizeSelect.disabled=!ref;
      ref?.sizes.forEach(size=>{const option=el('option','',size);option.value=size;sizeSelect.append(option);});
      $('[data-fit-result]',studio).hidden=true;
    });
    $$('[data-fit-mode]',studio).forEach(button=>button.addEventListener('click',()=>{
      $$('[data-fit-mode]',studio).forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      $$('[data-fit-panel]',studio).forEach(panel=>panel.hidden=panel.dataset.fitPanel!==button.dataset.fitMode);
      $('[data-fit-result]',studio).hidden=true;
    }));
    $('[data-fit-known-form]',studio).addEventListener('submit',event=>{
      event.preventDefault();const ref=catalog.products.find(p=>p.id === productSelect.value);
      const preference=$('#FitPreference',studio).value;const size=sizeSelect.value;
      const referenceProfile=ref&&profiles.profiles[ref.id];
      const row=referenceProfile?.rows.find(r=>core.normalise(r.size)===core.normalise(size));
      const result=profile&&row?core.compareGarment(profile,row.width,row.length,'cm',preference):core.compareReference(current,ref,size,preference);
      showResult(result,current,ref,profile,variants,studio,(ref?.title || '')+' · '+size+' · '+preference);
    });
    let priorUnit='cm';
    $('#FitUnits',studio).addEventListener('change',event=>{
      const next=event.target.value; const factor=priorUnit==='cm'?1/2.54:2.54;
      ['#FitWidth','#FitLength'].forEach(selector=>{const input=$(selector,studio);if(input.value && next!==priorUnit) input.value=String(Math.round(Number(input.value)*factor*10)/10);});
      priorUnit=next;$$('[data-fit-unit]',studio).forEach(span=>span.textContent=next);$('[data-fit-result]',studio).hidden=true;
    });
    $('[data-fit-measure-form]',studio).addEventListener('submit',event=>{
      event.preventDefault();const width=$('#FitWidth',studio).value,length=$('#FitLength',studio).value,unit=$('#FitUnits',studio).value;
      const result=core.compareMeasurements(profile,width,length,unit);
      showResult(result,current,null,profile,variants,studio,text('fit_width_short')+': '+width+' '+unit+'\n'+text('fit_length_short')+': '+length+' '+unit);
    });
    // Avoid a stale result after a shopper changes their inputs.
    studio.addEventListener('input',event=>{if(event.target.closest('form')) $('[data-fit-result]',studio).hidden=true;});
    drawChart(profile,studio);
    if (profile?.rows?.length) $('[data-fit-mode="measure"]',studio).click();
  }
  const fitDialog = $('#FitDialog');
  fitDialog?.addEventListener('close', () => { if (!fitDialog.open) request?.abort(); });
  async function loadFit(productUrl) {
    request?.abort(); request = new AbortController(); const active = request;
    const content = $('#FitContent'); if (!content) return;
    content.setAttribute('aria-busy', 'true');
    content.replaceChildren(el('p', 'quick-loading', text('loading')));
    let timedOut = false;
    const timer = setTimeout(() => { timedOut = true; active.abort(); }, 18000);
    const isCurrent = () => request === active && !!fitDialog?.open;
    try {
      const url = new URL(productUrl, location.origin); url.hash = ''; url.searchParams.set('section_id', 'atelier-fit');
      const response = await fetch(url, {signal:active.signal}); if (!response.ok) throw new Error(text('error'));
      const html = await response.text(); if (active.signal.aborted || !isCurrent()) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const studio = $('[data-fit-studio]', parsed); if (!studio) throw new Error(text('error'));
      // Do not expose native forms before their data and submit handlers are ready.
      studio.hidden = true; studio.inert = true; content.append(studio);
      await init(studio, active.signal);
      if (timedOut) throw new Error(text('error'));
      if (active.signal.aborted || !isCurrent()) return;
      content.replaceChildren(studio); studio.hidden = false; studio.inert = false;
    } catch (error) {
      if (!isCurrent() || (active.signal.aborted && !timedOut)) return;
      const box = el('div', 'quick-loading'); box.append(el('p', '', text('error')));
      const retry = el('button', 'button', text('retry')); retry.type = 'button';
      retry.addEventListener('click', () => loadFit(productUrl)); box.append(retry);
      // Keep the shopper on their product. The original guide remains an alternative.
      const guide = el('a', 'text-link', text('fit_chart'));
      const destination = new URL(productUrl, location.origin); destination.hash = '';
      guide.href = destination.href;
      const localGuide = $('.product-details details[id^="SizeGuide-"]');
      if (localGuide && destination.pathname === location.pathname) {
        guide.href = '#' + localGuide.id;
        guide.addEventListener('click', event => { event.preventDefault(); fitDialog.close(); localGuide.open = true; localGuide.scrollIntoView({block:'center',behavior:'instant'}); $('summary',localGuide)?.focus({preventScroll:true}); });
      }
      box.append(guide); content.replaceChildren(box);
    } finally {
      clearTimeout(timer); if (request === active) content.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-fit-url]');
    if (!trigger || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (!core || !window.AtelierDialogs || !fitDialog) return;
    event.preventDefault(); sourceForm = trigger.closest('form') || $('.product-details [data-product-form]');
    // The fit entry works independently of the order of document click listeners.
    if (!fitDialog.open && !window.AtelierDialogs.open('FitDialog', trigger)) return;
    loadFit(trigger.dataset.fitUrl);
  });
  const directory=$('[data-fit-directory]');
  if(directory) {
    const area=$('[data-fit-directory-results]',directory), status=$('[data-fit-directory-status]',directory);
    status.textContent=text('loading');
    Promise.all([json(directory.dataset.catalogUrl),json(directory.dataset.profilesUrl)]).then(([catalog,profiles])=>{
      profiles.profiles=Object.fromEntries(catalog.products.map(p=>[p.id,core.selectProfile(p,profiles,null)]).filter(([,p])=>p));
      const ordered=[...catalog.products].sort((a,b)=>Number(!!profiles.profiles[b.id])-Number(!!profiles.profiles[a.id]));
      function renderDirectory(){
        const query=$('#FitDirectorySearch',directory).value.trim().toLocaleLowerCase();
        const matches=ordered.filter(p=>(p.label||p.title).toLocaleLowerCase().includes(query)).slice(0,12);
        area.replaceChildren();status.textContent=matches.length?'':text('no_results');
        matches.forEach(p=>{const a=el('a');a.href=root+'products/'+p.handle;a.dataset.fitUrl=a.href;a.dataset.open='FitDialog';
          if(p.image){const img=el('img');const url=new URL(p.image);url.searchParams.set('width','160');img.src=url.href;img.alt='';img.width=70;img.height=88;img.loading='lazy';a.append(img);}
          const info=el('div');info.append(el('strong','',p.label||p.title),el('small','',text(profiles.profiles[p.id]?'fit_directory_chart':'fit_directory_known')));a.append(info);area.append(a);
        });
      }
      $('#FitDirectorySearch',directory).addEventListener('input',renderDirectory);renderDirectory();
    }).catch(()=>{status.textContent=text('error');});
  }
})();
